import React from "react";

import DonutChart from "../../components/global/DonutChart";
import PaymentHealthWorker from "../../components/Users/HealthWorkersUsers/healthWorker/PaymentHealthWorker";
import { images } from "../../constants/icons";

const PaymentHealthContainer = () => {
  const title = "Payment";
  return (
    <div className="p-6">
      <div className="flex justify-between items-center ">
        <p className="text-base font-bold py-4"> {title}</p>
      </div>

      <div className="flex justify-center">
        <div className="h-[141.22px] w-[121.22px] py-4">
          <DonutChart />
        </div>
      </div>
      <PaymentHealthWorker />
    </div>
  );
};

export default PaymentHealthContainer;
